module.exports = __webpack_public_path__ + "static/featured-post-0efa9f8dfa80847c241c45962da19fb2.png";